import React from "react";
import { ModalType, ModalContextInterface } from "types/modal";

export const ModalContext = React.createContext<ModalContextInterface>({
  isOpen: false,
  type: "",
  open: (_type: ModalType) => {},
  close: (currentUserId: string | null) => {},
});
